/*
    TIDIO
    forged by Andrew Vink
    Copyright 2025
*/

/*
------------------------
TIDIO - LIVE CHAT APP
------------------------

Channels > Appearance > Visibilty & Position
URL: /panel/settings/live-chat/appearance

We need to leave this ON for both Mobile & Desktop - the app doesn't just hide the widget it disables it entirely.
*/

(function () {
  function onTidioChatApiReady() {
    // console.log("hiding");
    window.tidioChatApi.hide();
  }

  function initializeTidioApi() {
    // console.log("Initializing tidio");
    if (window.tidioChatApi) {
      window.tidioChatApi.on("ready", onTidioChatApiReady);
    } else {
      // If Tidio API isn't ready yet, check again in 100ms
      setTimeout(initializeTidioApi, 100);
    }
  }

  initializeTidioApi();

  // if (window.tidioChatApi) {
  //   window.tidioChatApi.on("ready", onTidioChatApiReady);
  // }

  document.addEventListener("DOMContentLoaded", function () {
    // console.log("DOM CONTENT LOADED. TIDIO APP");
    const chatButton = document.querySelector(".chat-button");
    // console.log("tido button : ", chatButton);
    if (!chatButton) {
      return;
    }

    // document
    //   .querySelector(".chat-button")
    chatButton.addEventListener("click", function () {
      window.tidioChatApi.show();
      window.tidioChatApi.open();
    });
  });
})();
